<div class="min-h-screen  text-gray-900 flex justify-center bg-[linear-gradient(135deg,hsl(240_100%_4%)_0%,hsl(200_100%_8%)_20%,hsl(195_100%_12%)_40%,hsl(180_95%_15%)_60%,hsl(200_85%_18%)_80%,hsl(240_70%_8%)_100%)]">
    <div class="  m-0 sm:m-10 bg-[linear-gradient(135deg,hsl(240_100%_4%)_0%,hsl(200_100%_8%)_20%,hsl(195_100%_12%)_40%,hsl(180_95%_15%)_60%,hsl(200_85%_18%)_80%,hsl(240_70%_8%)_100%)] shadow sm:rounded-lg flex justify-center flex-1">

        <div class="lg:w-1/2 xl:w-5/12 p-6 sm:p-12">
            <div class="w-60 mx-auto">
                <img src="assets/6b69e5fc-0d9c-40f3-abfc-62866696e1ad.png" alt="Logo" class="w-60 h-52 rounded-[1.5vw]">
            </div>
            <div class="mt-10 flex flex-col items-center">


                <!-- Login Form -->
                <div *ngIf="!showForgotPassword">
                    <h1 class="text-2xl xl:text-3xl font-extrabold text-white">
                        Connectez-vous à votre compte
                    </h1>
                    <span class="text-white">
                        Vous n'avez pas de compte ?
                        <a class="text-indigo-500 hover:text-indigo-700 font-bold cursor-pointer" (click)="goToRegister()">
                            S'inscrire
                        </a>
                    </span>
                </div>

                <!-- Forgot Password Form -->
                <div *ngIf="showForgotPassword">
                    <h1 class="text-2xl xl:text-3xl font-extrabold text-white">
                        Réinitialiser le mot de passe
                    </h1>
                    <span class="text-white">
                        Retour à la
                        <button type="button" class="text-indigo-500 hover:text-indigo-700 font-medium"
                            (click)="toggleForgotPassword()">
                            connexion
                        </button>
                    </span>
                </div>

                <!-- Error/Success Messages -->
                <div *ngIf="errorMessage$ | async as error">
                    <p class="text-red-600 bg-red-100 border border-red-400 rounded p-3 mt-4">
                        {{ error }}
                    </p>
                </div>

                <div *ngIf="successMessage">
                    <p class="text-green-600 bg-green-100 border border-green-400 rounded p-3 mt-4">
                        {{ successMessage }}
                    </p>
                </div>

                <div class="w-full flex-1 mt-8">
                    <div class="my-12  text-center">
                        <div
                            class="leading-none px-2 inline-block font-bold text-xl   text-white  tracking-wide   transform translate-y-1/2">
                            {{ showForgotPassword ? 'Entrez votre email' : 'Se connecter avec e-mail' }}
                        </div>
                    </div>

                    <!-- Login Form -->
                    <form *ngIf="!showForgotPassword" class="mx-auto max-w-xs" (ngSubmit)="onSubmit()" ngNativeValidate>
                        <input
                            class="w-full text-[16px] px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 focus:outline-none focus:border-gray-400 focus:bg-white"
                            type="email" placeholder="Email" name="email" id="email" required
                            [(ngModel)]="user.email" />
                        <input
                            class="w-full text-[16px] px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 focus:outline-none focus:border-gray-400 focus:bg-white mt-5"
                            type="password" placeholder="Password" name="password" id="password" required
                            [(ngModel)]="user.password" />

                        <button type="submit" [disabled]="isLoading()" [ngClass]="{
                            'bg-[linear-gradient(135deg,hsl(200_95%_45%),hsl(195_100%_50%))] hover:bg-indigo-700': !isLoading(),
                            'bg-gray-400 cursor-not-allowed': isLoading()
                        }"
                            class="mt-5 tracking-wide font-semibold text-gray-100 w-full py-4 rounded-lg transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none">
                            <svg class="w-6 h-6 -ml-2" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                                <path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                                <circle cx="8.5" cy="7" r="4" />
                                <path d="M20 8v6M23 11h-6" />
                            </svg>
                            <span class="ml-3 ">Se connecter</span>
                        </button>

                        <!-- Forgot Password Link -->
                        <div class="text-center mt-4">
                            <button type="button" class="text-sm text-indigo-500 hover:text-indigo-700 font-medium"
                                (click)="toggleForgotPassword()">
                                Mot de passe oublié ?
                            </button>
                        </div>
                    </form>

                    <!-- Forgot Password Form -->
                    <form *ngIf="showForgotPassword" class="mx-auto max-w-xs" (ngSubmit)="onForgotPassword()"
                        ngNativeValidate>
                        <input
                            class="w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-[16px] focus:outline-none focus:border-gray-400 focus:bg-white"
                            type="email" placeholder="Votre adresse email" name="resetEmail" id="resetEmail" required
                            [(ngModel)]="resetEmail" />

                        <button type="submit" [disabled]="isResetting" [ngClass]="{
                            'bg-[linear-gradient(135deg,hsl(200_95%_45%),hsl(195_100%_50%))] hover:bg-indigo-700': !isResetting,
                            'bg-gray-400 cursor-not-allowed': isResetting
                        }"
                            class="mt-5 tracking-wide font-semibold text-gray-100 w-full py-4 rounded-lg transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none">
                            <svg *ngIf="!isResetting" class="w-6 h-6 -ml-2" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                <polyline points="22,6 12,13 2,6" />
                            </svg>
                            <svg *ngIf="isResetting" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                            <span class="ml-3 ">{{ isResetting ? 'Envoi en cours...' : 'Envoyer le lien' }}</span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>